import { faker } from '@faker-js/faker'

import { RatingScaleType } from '../../contracts/review'
import { RatingScale } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getRatingScale = asBuilder((): RatingScale => {
  return {
    type: faker.helpers.enumValue(RatingScaleType),
    description: faker.string.uuid(),
    percentage: faker.number.int(),
  }
})
